import { useErrorMonitor, useHttpClient } from '@wix/fe-essentials-standalone';
import { useQuery } from '@tanstack/react-query';
import { countFavoriteTemplates } from './templateFavoritesApi';
import { templateFavoritesQueryKeys } from './templateFavoritesQueryKeys';

export const useTemplateFavoritesCount = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const httpClient = useHttpClient();
  const errorMonitor = useErrorMonitor();

  const countQuery = useQuery({
    queryKey: templateFavoritesQueryKeys.count(),
    enabled,
    retry: false,
    queryFn: async () => {
      try {
        return await countFavoriteTemplates(httpClient);
      } catch (error) {
        errorMonitor.captureException(error as Error);
        return 0;
      }
    },
  });

  return { favoriteCount: countQuery.data ?? 0 };
};
